import { Component, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiAcuerdosGestores, PoseedorPayloadDTO, ConsentimientoControllerService } from 'api-rest';
import { SnackbarService } from '../../services/snackbar.service';
import { SpinnerService } from '../../services/spinner.service';
import moment from 'moment';

@Component({
  selector: 'managers-agreements-indirect-agreement-upload-agreement-modal',
  templateUrl: './indirect-agreement-upload-agreement-modal.component.html',
  styleUrls: ['./indirect-agreement-upload-agreement-modal.component.scss']
})
export class IndirectAgreementUploadAgreementModalComponent {
 formGroup!: FormGroup;
  acuerdoIndirectoInfo!: any;
  adjuntosBlob: Array<File> = [];
  poseedorAcuerdo!: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<IndirectAgreementUploadAgreementModalComponent>,
    private formBuilder: FormBuilder,
    public spinnerSrv: SpinnerService,
    private consentimientoControllerService: ConsentimientoControllerService,
    private snackBarSrv: SnackbarService
  ) {
    this.formGroup = this.formBuilder.group({
      fechaFirma: [{ value: null, disabled: false }, [Validators.required, fechaPosteriorHoyValidator()]],
    });
  }

  ngOnInit(): void {
    this.acuerdoIndirectoInfo = this.data?.acuerdoIndirectoInfo;
    this.poseedorAcuerdo = this.data?.poseedorAcuerdo;

  }

  cerrar(): void {
    this.dialogRef.close(null);
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.formGroup.controls[controlName].hasError(errorName) &&
      this.formGroup.controls[controlName].touched
    );
  }

  getFormControl(controlName: string): FormControl {
    return this.formGroup.controls[controlName] as FormControl;
  }

  guardar(): void {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.invalid || this.adjuntosBlob.length === 0) {
      this.snackBarSrv.showSnackBar('Debe completar los campos obligatorios', 'error');
      return;
    }

    this.spinnerSrv.loadingShow();
    this.consentimientoControllerService.subirConsentimientoFirmado(this.poseedorAcuerdo.id, moment(this.formGroup.controls['fechaFirma'].value).format('YYYY-MM-DD'), this.adjuntosBlob[0]).subscribe({
      next: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Consentimiento subido correctamente', 'success');
        this.dialogRef.close({ saved: true });
      },
      error: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Ha ocurrido un error al subir el consentimiento', 'error');
      } 
    });
  }
    attachAdjunto(archivo: File | null): void {
    if (archivo != null) {
      if (archivo.size === 0) {
        this.snackBarSrv.showSnackBar(
          'No se puede subir un fichero vacío',
          'error'
        );
      } else if (archivo.size > 12 * 1024 * 1024) { // 5 MB
        this.snackBarSrv.showSnackBar(
          'El fichero supera el tamaño máximo permitido de 12 MB',
          'error'
        );
      } else {
        this.adjuntosBlob.push(archivo);
      }
    }
  }
}
export function fechaPosteriorHoyValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
        return null;
    }
    const fechaIngresada = new Date(control.value);
    const hoy = new Date();
    
    // Poner horas a cero para comparar solo los días
    hoy.setHours(0, 0, 0, 0);
    fechaIngresada.setHours(0, 0, 0, 0);

    return fechaIngresada <= hoy ? null : { fechaNoPosterior: true };
  };
}